import { config } from 'env';

export const MAX_CERTIFICATE_ACCOUNTS = 5;
// achievement-manager's per-user cap; past it GenerateCertificate answers RESOURCE_EXHAUSTED.
export const DAILY_CERTIFICATE_LIMIT = 20;

// Stable keys for state and analytics; api.ts maps them to the service's TimeRange enum (UTC days, Monday weeks).
export const RANGE_PRESETS = {
  today: 'today',
  yesterday: 'yesterday',
  thisWeek: 'this_week',
  lastWeek: 'last_week',
  thisMonth: 'this_month',
  lastMonth: 'last_month'
} as const;

export const RANGE_OPTIONS = Object.values(RANGE_PRESETS);
export const DEFAULT_RANGE = RANGE_PRESETS.thisWeek;

export const ACCOUNTS_PAGE_SIZE = 50;

// /dashboard?new-certificate opens the dialog straight away (the What's New post's button links here).
export const CERTIFICATE_OPEN_PARAM = 'new-certificate';

// Public certificate pages live on the marketing site: /share/certificate/<id>, artwork at .../<id>/image.
export const CERTIFICATE_SITE_URL = config.certificateSiteUrl;
export const CERTIFICATE_PATH = 'share/certificate';
export const CERTIFICATE_IMAGE_PATH = 'image';
export const CERTIFICATE_DOWNLOAD_NAME = 'tradersconnect-certificate';
export const CERTIFICATE_IMAGE_EXTENSION = 'png';
// Artwork aspect from the approved design export (1414×2000).
export const CERTIFICATE_ASPECT_RATIO = '1414 / 2000';

export const SHARE_CHANNELS = ['x', 'linkedin', 'facebook', 'whatsapp', 'telegram'] as const;
// The other ways to share; each is also a `channel` on certificate:shared, so one breakdown names them all.
export const SHARE_METHODS = { native: 'native', copyLink: 'copy_link', download: 'download' } as const;

// Share-intent endpoints; each takes the public link (and optional text) as query params.
export const SHARE_INTENTS = {
  x: { base: 'https://x.com/intent/post', urlParam: 'url', textParam: 'text' },
  linkedin: { base: 'https://www.linkedin.com/sharing/share-offsite/', urlParam: 'url' },
  facebook: { base: 'https://www.facebook.com/sharer/sharer.php', urlParam: 'u' },
  whatsapp: { base: 'https://wa.me/', textParam: 'text' },
  telegram: { base: 'https://t.me/share/url', urlParam: 'url', textParam: 'text' }
} as const;

// Hover tint per network, from each brand's guidelines; X follows the text colour.
export const SHARE_BRAND_COLORS: Partial<Record<(typeof SHARE_CHANNELS)[number], string>> = {
  linkedin: '#0A66C2',
  facebook: '#1877F2',
  whatsapp: '#25D366',
  telegram: '#229ED9'
};

export const SNACKBAR_DURATION_MS = 3000;
export const COPY_FEEDBACK_MS = 2000;
export const DIALOG_WIDTH_PX = { narrow: 600, wide: 880 } as const;

// How far along the header progress bar sits on each step (0-1).
export const STEP_PROGRESS = { configure: 0.34, generating: 0.72, ready: 1, failed: 0.34 } as const;

export const CERTIFICATE_FAILURES = ['noData', 'dailyLimit', 'busy', 'error'] as const;
// Failures where the same selection can simply be sent again.
export const RETRYABLE_FAILURES: ReadonlyArray<(typeof CERTIFICATE_FAILURES)[number]> = ['busy', 'error'];
// The generating step rotates through its status lines at this pace.
export const GENERATING_LINE_MS = 1100;
// Max preview tilt toward the cursor, in degrees.
export const PREVIEW_TILT_DEG = 7;
